import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Logo from "../../../../assets/logo-white.svg";
import { Link, useHistory } from "react-router-dom";
import Admins from "../../../../assets/user.svg";
import authHeader from "../../../../services/auth-header";
import saas_agreement from "../../../../assets/saas_agreement.txt";
import store from "../../../../reducers/store";

import Discovery from "../../../../assets/discovery.svg";
import Certificateoff from "../../../../assets/menu/certificate.png";
import Certificate from "../../../../assets/menu/certificatenoactive.png";
import Auditoff from "../../../../assets/menu/audit.svg";
import Event from "../../../../assets/events.svg";
import Overviewoff from "../../../../assets/menu/overview.png";
import Overview from "../../../../assets/menu/overviewnoactive.png";
import Policyoff from "../../../../assets/menu/policy.png";
import Policy from "../../../../assets/menu/policynoactive.png";
import Ldapoff from "../../../../assets/menu/settings.png";
import Ldap from "../../../../assets/menu/settingsnoactive.png";
import Users from "../../../../assets/useron.svg";
import Usersoff from "../../../../assets/useroff.svg";
import External from "../../../../assets/external-link.svg";
import Support from "../../../../assets/support.svg";

import SharedUtils from "../../Common/utils";



import "./sidebar.scss";

const Sidebar = () => {
    const [brandImg, setBrandImg] = useState(null);
    const [dnsPanel, setDnsPanel] = useState(null);
    const [raSupport, setRaSupport] = useState(null);
    const dispatch = useDispatch();
    const history = useHistory();
    const isOpen = useSelector((state) => state.header.isOpen);




    const getSaasAgreement = async () => {
    function waitForButton() {
        return new Promise(resolve => {
            document.getElementById('acceptBtn').addEventListener('click', () => {
                const response = SharedUtils.apiPost("set_admin_saas_agreement", {});
                var element = document.getElementById('saasagreement');
                if (element) {
                    element.style.display = 'none';
                }
                var element = document.getElementById('overlay');
                if (element) {
                    element.style.display = 'none';
                }
                resolve(); // Resolve the promise when the button is clicked
            });
        });
    }

    try {

        const response = await SharedUtils.apiPost("admin_saas_agreement", {});
        let show_saas_agreement = !response[0];
        if (show_saas_agreement) {
            var saas_agreement_text;
            await fetch(saas_agreement)
             .then(r => r.text())
             .then(text => {
                saas_agreement_text = text;
              });

            const appRoot = document.getElementById('root');
            const customElement = document.createElement('div');
            customElement.innerHTML = '<div id=saasagreement style="position:fixed;top:0;left:0;width:100%;height:100%;background-color:#131b23;z-index:9999;opacity:.5"></div><div id=overlay style="position:fixed;top:0;left:0;width:50%;height:90%;background-color:#4d5053;z-index:9999;overflow-y:auto;white-space:pre-wrap;color:#fff;font-size:12px;border:3px solid #1f2535;border-color:#314c68;border-radius:8px;margin-top: 20px;margin-left: 30%;"><div style="margin:15px;">' + saas_agreement_text+ '<button id="acceptBtn" style="background: #000;border: unset;border-radius: 6px;color: #b7bcd2;font-family: Inter, sans-serif;font-size: 14px;font-weight: 600;height: 40px;width: 184px;margin-bottom: 15px;left: 40%;position: relative;">Accept</button></div></div>';
            appRoot.parentNode.insertBefore(customElement, appRoot);
            await waitForButton();
        }
    } catch (error) {
        console.error("Error fetching EULA:", error);
    } finally {
        getMeta();
        }
    };


    const getMeta = () => {
        var r = SharedUtils.apiPost("meta", {}).then((response) => {
            localStorage.setItem("client_name", response[0]['client_name']);
            store.dispatch({
                type: "TRIGGER_CLIENT_NAME_UPDATE",
                payload: true,
            })
            setDnsPanel(!response[0]['dns'])
            setRaSupport(response[0]['ra_support'])
            window.config.ff_fullpanel = !response[0]['dns']
            if(response[0]['demo_days'] != ''){
            const appRoot = document.getElementById('root');
            const customElement = document.createElement('div');
            customElement.innerHTML = '<div style=background-color:#f00;color:#000!important;;padding:10px;text-align:center;width:100%;height:40px;font-size:14px;>Your Trial ends in '+response[0]['demo_days']+' days</div>';
            appRoot.parentNode.insertBefore(customElement, appRoot);}

        }).finally(() => {
            // this.setState({ load_done: true });
        });
    }

    useEffect(() => {
    // Call the loadLogo function when the component mounts
    getSaasAgreement();
  }, []);

    const handleClose = () => {
        dispatch({
            type: "TRIGGER_SIDEBAR_MENU",
            payload: false,
        });
    };


    const loadLogo = async () => {

        await SharedUtils.apiPost("brandimg").then((response) => {
            setBrandImg(response[0]);
        })
    }

    useEffect(() => {
    loadLogo();
    }, []);

    return (
        <>
            <div
                className={`col-lg-2 col-md-1 col-sm-2 col-2 ps-0 pe-0 mobile-view-class`}
                style={{ "display": authHeader() == "" ? "none" : "block" }}
            >
                <div
                    className={`sidebar ${isOpen ? "mobile-sidebar-open" : "mobile-sidebar-close"
                        }`} style={{"bottom":"0","minHeight":"100vh"}}
                >
                    <div className="sidebar-close">
                        <IconButton onClick={handleClose}>
                            <CloseIcon sx={{ color: "#8d91a9" }} />
                        </IconButton>
                    </div>
                    <div className="logo">
                        <a href="/"> <img className="desktop-logo" src={Logo} alt="logo" /></a>
                    </div>
                        {brandImg && <img src={brandImg} id="clogo"
                            style={{
                                "margin-left": "20px","margin-bottom": "20px", maxWidth: "80px", maxHeight: "50px"
                            }} />}

                    <div className="menu-list">
                        <ul>
                            <li
                                className={
                                    history.location.pathname === "/overview" || history.location.pathname === "/" || history.location.pathname === ""
                                        ? "active-link"
                                        : null
                                }
                            >
                                <Link
                                    className="desktop-link"
                                    to="/overview"
                                    onClick={handleClose}
                                >
                                    <img
                                        className="img-fluid2 me-2"
                                        src={
                                            history.location.pathname === "/overview" || history.location.pathname === "/" || history.location.pathname === ""
                                                ? Overviewoff
                                                : Overview
                                            }
                                        alt="overview"
                                    />
                                    Overview
                                </Link>
                            </li>
                            <li
                                className={
                                    history.location.pathname.includes("/events") ? "active-link" : null
                                }
                            >
                                <Link
                                    className="desktop-link"
                                    to="/events/detection"
                                    onClick={handleClose}
                                    data_testid="events"
                                >
                                    <img className="img-fluid2 me-2" src={
                                        history.location.pathname.includes("/events") ? Event : Event
                                    } alt="events" />
                                    Events
                                </Link>
                            </li>
                            {
                                (history.location.pathname.includes("/events")) &&

                                <ul className="submenu">
                                    <li><Link
                                            className={history.location.pathname.includes("/events/detection") ? "sub-link-active" : "sub-link"}
                                            to="/events/detection"
                                        data_testid="detction_events_menu"
                                    >Detection</Link></li>

                                    </ul>
                            }
                            {
                                (history.location.pathname.includes("/events")) &&
                                <ul className="submenu">
                                    <li><Link
                                            className={history.location.pathname.includes("/events/restriction") ? "sub-link-active" : "sub-link"}
                                            to="/events/restriction"
                                        data_testid="restriction_events_menu"
                                    >Restriction</Link></li>

                                    </ul>
                            }
                            {window.config.ff_saas_vis &&
                            <li
                                className={
                                    history.location.pathname.includes("/visibility") ? "active-link" : null
                                }
                            >
                                <Link
                                    className="desktop-link"
                                    to="/visibility/saas"
                                    onClick={handleClose}
                                    data_testid="visibility"
                                >
                                    <img className="img-fluid2 me-2" src={
                                        history.location.pathname.includes("/visibility") ? Discovery : Discovery


                                    } alt="visibility" />
                                    Discovery
                                </Link>

                            </li>
                            }
                            {
                                (history.location.pathname.includes("/visibility")) &&

                                <ul className="submenu">
                                    <li><Link
                                            className={history.location.pathname.includes("/visibility/saas") ? "sub-link-active" : "sub-link"}
                                            to="/visibility/saas"
                                        data_testid="filemenu"
                                    >SaaS Control</Link></li>
                                    
                                    </ul>
                            }
                            {
                                (history.location.pathname.includes("/visibility")) &&
                                <ul className="submenu">
                                    <li><Link
                                            className={history.location.pathname.includes("/visibility/traffic") ? "sub-link-active" : "sub-link"}
                                            to="/visibility/traffic"
                                        data_testid="trafficmenue"
                                    >Traffic records</Link></li>

                                    </ul>
                            }
                            {
                                (history.location.pathname.includes("/visibility")) &&
                                <ul className="submenu">
                                    <li><Link
                                            className={history.location.pathname.includes("/visibility/ext") ? "sub-link-active" : "sub-link"}
                                            to="/visibility/ext"
                                        data_testid="discoveryusersmenue"
                                    >Extensions</Link></li>

                                    </ul>
                            }
                            <li
                                className={
                                    history.location.pathname.includes("/policy") ? "active-link" : null
                                }
                            >
                                <Link
                                    className="desktop-link"
                                    to={dnsPanel ? "/policy/browser" : "/policy/browser_pr"}
                                    onClick={handleClose}
                                    data_testid="urlmenuparent"
                                >
                                    <img className="img-fluid2 me-2" src={
                                        history.location.pathname.includes("/policy") ? Policyoff : Policy
                                        

                                    } alt="policy" />
                                    Policy and web control
                                </Link>

                            </li>

                            {
                                (history.location.pathname.includes("/policy")) &&

                                <ul className="submenu">

                                         { dnsPanel &&
                                         <li><Link
                                            className={history.location.pathname.includes("/policy/browser") ? "sub-link-active" : "sub-link"}
                                            to="/policy/browser"
                                            data_testid="filemenu"
                                            >Browser Protection</Link></li>
                                         }
                                         { !dnsPanel &&
                                         <li><Link
                                            className={history.location.pathname.includes("/policy/browser_pr") ? "sub-link-active" : "sub-link"}
                                            to="/policy/browser_pr"
                                            data_testid="filemenu"
                                            >Browser Protection</Link></li>
                                         }
                                        <li><Link
                                            className={history.location.pathname.includes("/policy/urlfilter") ? "sub-link-active" : "sub-link"}
                                            to="/policy/urlfilter"
                                            data_testid="urlmenu"
                                        >
                                            URL Filtering
                                        </Link></li>
                                        { dnsPanel &&
                                        <li><Link
                                            className={history.location.pathname.includes("/policy/filescan") ? "sub-link-active" : "sub-link"}
                                            to="/policy/filescan"
                                            data_testid="filemenu"
                                            >File Scan</Link></li>
                                        }
                                        { dnsPanel &&
                                        <li><Link
                                            className={history.location.pathname.includes("/policy/ext") ? "sub-link-active" : "sub-link"}
                                            to="/policy/ext"
                                            data_testid="filemenu"
                                        >Browser Extensions</Link></li>
                                        }
                                        { dnsPanel &&
                                        <li><Link
                                            className={history.location.pathname.includes("/policy/dlp") ? "sub-link-active" : "sub-link"}
                                            to="/policy/dlp"
                                            data_testid="dlpmenu"
                                            >Data Loss Prevention</Link></li>
                                        }
                                        { dnsPanel &&
                                         <li><Link
                                            className={history.location.pathname.includes("/policy/awareness") ? "sub-link-active" : "sub-link"}
                                            to="/policy/awareness"
                                            data_testid="userawareness"
                                            >User Awareness</Link></li>
                                         }
                                       
                                    {/*<li><Link*/}
                                    {/*        className={history.location.pathname.includes("/policy/blockurl") ? "sub-link-active" : "sub-link"}*/}
                                    {/*    to="/policy/blockurl"*/}
                                    {/*>*/}
                                    {/*    Block List*/}
                                    {/*</Link></li>*/}
                                    {/*<li><Link*/}
                                    {/*        className={history.location.pathname.includes("/policy/ignoreurl") ? "sub-link-active" : "sub-link"}*/}
                                    {/*    to="/policy/ignoreurl"*/}
                                    {/*>*/}
                                    {/*    Ignore List*/}
                                    {/*</Link></li>*/}
                                    {/*<li>*/}
                                    {/*    <Link*/}
                                    {/*            className={history.location.pathname.includes("/policy/appcontrol") ? "sub-link-active" : "sub-link"}*/}
                                    {/*        to="/policy/appcontrol"*/}
                                    {/*    >*/}
                                    {/*        Application Control*/}
                                    {/*    </Link>*/}
                                    {/*</li>*/}
                                    {/*<li><Link*/}
                                    {/*        className={history.location.pathname.includes("/policy/proxy") ? "sub-link-active" : "sub-link"}*/}
                                    {/*    to="/policy/proxy"*/}
                                    {/*>*/}
                                    {/*    Proxy*/}
                                    {/*</Link></li>*/}
                                </ul>


                            }


                            <li
                                className={
                                    ((history.location.pathname.includes("/config") || history.location.pathname.includes("/certificates")) &&
                                        !history.location.pathname.includes("/config/pac")) ? "active-link" : null
                                }
                            >
                                <Link
                                    className="desktop-link"
                                    to="/config/ldap"
                                    onClick={handleClose}
                                    data_testid="ldapmenuparent"
                                >
                                    <img className="img-fluid2 me-2" src={
                                        ((history.location.pathname.includes("/config") || history.location.pathname.includes("/certificate"))
                                        && !history.location.pathname.includes("/config/pac")) ? Ldapoff : Ldap
                                        

                                    } alt="config" />
                                    Config
                                </Link>
                            </li>


                            {
                                ((history.location.pathname.includes("/config") || history.location.pathname.includes("/certificates")) &&
                                    !history.location.pathname.includes("/config/pac")) &&

                                <ul className="submenu">
                                    { dnsPanel &&
                                    <li>
                                        <Link
                                            className={history.location.pathname.includes("/config/ldap") ? "sub-link-active" : "sub-link"}
                                                to="/config/ldap"
                                                data_testid="ldapmenu">
                                            AD Sync
                                        </Link>
                                    </li>
                                    }
                                    <li>
                                        <Link
                                            className={history.location.pathname.includes("/config/siem") ? "sub-link-active" : "sub-link"}
                                            to="/config/siem"
                                            data_testid="siemmenu">
                                            SIEM
                                        </Link>
                                    </li>
                                    { dnsPanel &&
                                    <li>
                                        <Link
                                            className={history.location.pathname.includes("/certificates") ? "sub-link-active" : "sub-link"}
                                            to="/certificates"
                                            onClick={handleClose}
                                            data_testid="certmenu">
                                            Certificate management
                                        </Link>
                                    </li>
                                    }
                                    <li>
                                        <Link
                                            className={history.location.pathname.includes("/config/brand") ? "sub-link-active" : "sub-link"}
                                            to="/config/brand"
                                            data_testid="brandmmenu">
                                            Branding
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            className={history.location.pathname.includes("/config/admins") ? "sub-link-active" : "sub-link"}
                                            to="/config/admins"
                                            data_testid="adminmenu">
                                            Managers & API Keys
                                        </Link>
                                    </li>
                                </ul>
                            }



                            { dnsPanel &&
                            <li>
                                <Link
                                    className={history.location.pathname.includes("/config/pac") ? "desktop-link" : "desktop-link"}
                                    to="/config/pac"
                                    data_testid="pacmmenu">
                                    <img
                                        className="img-fluid2 me-2"
                                        src={
                                            history.location.pathname === "/config/pac"
                                                ? Certificateoff
                                                : Certificate

                                        }
                                        alt="pac"
                                    />Service Control</Link>
                            </li>
                            }
                            { dnsPanel &&
                            (<>
                                <li className={
                                        history.location.pathname.includes("/license") ? "active-link" : null} >
                                    <Link
                                        className="desktop-link"
                                        to={"/license/users"}
                                        onClick={handleClose}
                                        data_testid="urlmenuparent">
                                        <img className="img-fluid2 me-2" src={
                                            history.location.pathname.includes("/license") ? Users : Usersoff
                                        } alt="License" />
                                        License
                                    </Link>
                                </li>
                                { (history.location.pathname.includes("/license")) &&

                                    <ul className="submenu">

                                        <li>
                                            <Link
                                                className={history.location.pathname.includes("/license/users") ? "sub-link-active" : "sub-link"}
                                                    to="/license/users"
                                                    data_testid="ldapmenu">
                                                Registered Users
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                className={history.location.pathname.includes("/license/installers") ? "sub-link-active" : "sub-link"}
                                                to="/license/installers"
                                                data_testid="siemmenu">
                                                Installers
                                            </Link>
                                        </li>
                                    </ul>
                                }</>)
                            }
                            <li
                                className={
                                    history.location.pathname === "/logs/audit" ? "active-link" : null
                                }
                            >
                                <Link
                                    className="desktop-link"
                                    to="/logs/audit"
                                    onClick={handleClose}
                                    data_testid="auditlogmenu"
                                >
                                    <img className="img-fluid2 me-2" src={history.location.pathname === "/logs/audit" ? Auditoff  : Auditoff} alt="audit" />
                                    Audit
                                </Link>
                            </li>
                            {raSupport &&
                                <li>
                                    <a
                                        className="desktop-link"
                                        href="https://redaccess.atlassian.net/servicedesk/customer/user/requests?page=1&statuses=open"
                                        onClick={handleClose}
                                        data_testid="support"
                                        target="_blank"
                                    >
                                        <img className="img-fluid2 me-2" src={Support} alt="support" />
                                        Support
                                        <img className="img-fluid2 me-2" src={External} alt="external" style={{ "padding-left": "16px", "margin-left": "-10px"}}/>
                                    </a>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sidebar;
